export default {
  S22_H_QD19: 'S22-H_QD19',
};
